import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Label from '../label/label';
import { setMultipleCheckboxValue, setSingleCheckboxValue } from 'zengenti-forms-package/redux/actions';
import {  useDispatch } from 'react-redux';

const CheckboxStyled = styled.div`
  ${({ useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
        css`
          .checkbox-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            input {
              height: auto;
              width: auto;
              margin: 0 4px 0 0;
            }
            label {
              display: inline-block;
            }
          }
        `}
    `;
  }};
`;

const Checkbox = ({
  className,
  formId,
  id,
  type,
  label,
  validations,
  defaultValue,
  name,
  defaultLanguage,
  useDefaultTheme,
}) => {
  // NF change rules of hooks
  let isDefaultChecked = defaultValue && defaultValue[defaultLanguage];
  const [isChecked, setIsChecked] = useState(isDefaultChecked || '');

  const dispatch = useDispatch()

  switch (type) {
    case 'multiple': {
      if (!validations) return null;
      const isRequired = validations && validations.required ? true : false;
      const cbValues =
        validations &&
        validations.allowedValues &&
        validations.allowedValues.values;

      const _handleChange = (label, value) => {
        dispatch(setMultipleCheckboxValue(formId, id, label, value));
      };

      if (!cbValues || cbValues.length < 1) return null;
      return (
        <CheckboxStyled
          className={`checkbox-container`}
          useDefaultTheme={useDefaultTheme}
        >
          <Label
            id={id}
            label={label}
            isRequired={isRequired}
            className="label-checkbox-container"
          />
          {cbValues.map((val, idx) => {
            return (
              <span key={idx} className="checkbox-wrapper">
                <input
                  type="checkbox"
                  id={`checkbox-${idx}`}
                  name={`checkbox-${idx}`}
                  value={val[defaultLanguage]}
                  className={`${className ? className : ''} input-checkbox`}
                  onChange={e =>
                    _handleChange(e.target.value, e.target.checked)
                  }
                />
                <label className="label-checkbox" id={`checkbox-${idx}`} htmlFor={`checkbox-${idx}`}>
                    {val[defaultLanguage]}
                </label>
              </span>
            );
          })}
        </CheckboxStyled>
      );
    }
    case 'single': {
      const _handleChange = value => {
        setIsChecked(value);
        dispatch(setSingleCheckboxValue(formId, id, value));
      };
      return (
        <CheckboxStyled
          className={`checkbox-container`}
          useDefaultTheme={useDefaultTheme}
        >
          <span className="checkbox-wrapper">
            <input
              type="checkbox"
              id={id}
              name={`checkbox-${id}`}
              value={name[defaultLanguage]}
              checked={isChecked}
              className={`${className ? className : ''} input-checkbox`}
              onChange={e => _handleChange(e.target.checked)}
            />
            <Label id={id} label={label} className="label-checkbox" />
          </span>
        </CheckboxStyled>
      );
    }
  }
};

Checkbox.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.object,
  defaultLanguage: PropTypes.string,
  name: PropTypes.object,
  default: PropTypes.object,
};

export default Checkbox;
